import * as React from 'react';
import { ResponsiveBar } from '@nivo/bar'
import Translate from '../../common/translate';
import * as HelperFunctions from '../../common/helperFunctions'
import { Months, TagType } from '../../common/enums';
import DataService from '../../services/dataSevice';
import Growl from '../../common/components/growl/growl';
import Paginator from '../../common/components/paginator'

declare module '@nivo/bar'

class BarModel {
    public month: string;
    public value: number;
    public valueColor: string;
}

interface IProps {
    history?: any;
    tagNumber: number;
    lang: string;
    width: number;
    height: number;
    paginator: boolean;
    popupChart: boolean;
    //animationState: string
}

interface IState {
    isLoading: boolean;
    barData: Array<BarModel>;
    maxMarker: number;
    page: number;
    selectedYear: number;
    yearsArray: Array<number>;
}

class BarChart extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: false,
            barData: new Array<BarModel>(0),
            maxMarker: 0,
            page: 5,
            selectedYear: 0,
            yearsArray: new Array<number>()
        }
    }

    growl: any;
    dataService = new DataService();

    componentDidMount() {
        let currentYear = new Date().getFullYear();
        let yearsArr = new Array<number>();
        for (let i = 4; i >= 0; i--) {
            yearsArr.push(currentYear - i);
        }
        this.setState({ selectedYear: currentYear, yearsArray: yearsArr }, () => {
            this.getBarData();
        });
    }

    getBarData = () => {
        if (this.props.tagNumber) {
            if (this.props.tagNumber !== TagType.InternalTemperature && this.props.tagNumber !== TagType.OutsideTemperature) {
                let currentYear = new Date().getFullYear();
                setTimeout(() => {
                    let data = this.dataService.fakeTagData(this.props.tagNumber);
                    // .then(
                    //     (data: any) => {
                    let newData: Array<number> = data;
                    let barData: Array<BarModel> = this.getBarArray(newData);
                    let maxBorder: number = 0;

                    let maxVal = Math.max(...newData);
                    let minVal = Math.min(...newData);
                    let delta = maxVal - minVal;
                    if (this.state.selectedYear === currentYear) {
                        let currMonth = new Date().getMonth();
                        barData = barData.splice(0, currMonth + 1)
                    }

                    maxBorder = maxVal !== 0 ? maxVal + (delta / 3) : 0;
                    this.setState({ barData: barData, maxMarker: maxBorder })
                    //     }
                    // ).catch(
                    //     (error: any) => {
                    //         this.growl.show({ severity: 'error', summary: error.message });
                    //     });
                }, 100);
            }
            else {

                let newData: Array<number> = new Array<number>(0);
                for (let i = 0; i < 12; i++) {
                    newData.push(Math.floor(Math.random() * 15) + 15)
                }
                let barData: Array<BarModel> = this.getBarArray(newData);
                let maxBorder: number = 0;

                let maxVal = Math.max(...newData);
                let minVal = Math.min(...newData);
                let delta = maxVal - minVal;


                maxBorder = maxVal !== 0 ? maxVal + (delta / 3) : 0;
                this.setState({ barData: barData, maxMarker: maxBorder })
            }
        }
    }

    getBarArray = (data: Array<number>) => {
        const months = HelperFunctions.getEnumKeys(Months);
        let barData = Array<BarModel>(0);
        for (let i = 0; i < months.length; i++) {
            let newBar = new BarModel();
            if (this.props.popupChart) {
                newBar.month = Translate(months[i]);
            }
            else {
                newBar.month = i + 1 + "";
            }
            if (data[i]) {
                newBar.value = data[i];
            } else {
                newBar.value = 0;
            }
            newBar.valueColor = this.getColor(i + 1);
            barData.push(newBar);
        }
        return barData;
    }

    getColor = (month: number) => {
        switch (month) {
            case Months.January:
            case Months.July:
                return '#e8c1a0';
            case Months.February:
            case Months.August:
                return '#f47560';
            case Months.March:
            case Months.September:
                return '#d9cb55';
            case Months.April:
            case Months.October:
                return '#e8a838';
            case Months.May:
            case Months.November:
                return '#4a978a';
            case Months.June:
            case Months.December:
                return '#61cdbb';
            default:
                return '#e8c1a0';
        }
    }

    paginataorClick = (page) => {
        this.setState({ page: page, selectedYear: this.state.yearsArray[page - 1] }, () => this.getBarData());
    }

    render() {
        const { barData, maxMarker, page } = this.state;
        let yearString = this.state.selectedYear + "";
        yearString += this.props.lang === 'bg' ? " г." : '';

        let axisBottom: any = {
            "tickSize": 5,
            "tickPadding": this.props.popupChart ? 15 : 5,
            "tickRotation": 0,
            "legend": "",
            "legendOffset": 46,
            "legendPosition": "middle",
            "color": this.props.popupChart ? 'black' : 'white',
        }

        return (
            <>
                <Growl ref={(el: any) => this.growl = el} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: this.props.width, height: this.props.height }}>
                        <ResponsiveBar
                            data={barData}
                            indexBy="month"
                            margin={this.props.popupChart ? {
                                "top": 10,
                                "right": 20,
                                "bottom": 60,
                                "left": 40
                            } : {
                                    "top": 5,
                                    "right": 5,
                                    "bottom": 20,
                                    "left": 5
                                }}
                            padding={0.3}
                            colors={({ id, data }) => data[`${id}Color`]}
                            // minValue={minVal != 0 ? minVal - (delta / 5) : "auto"}
                            axisTop={null}
                            theme={{
                                axis: {
                                    ticks: {
                                        text: {
                                            fill: this.props.popupChart ? 'black' : 'white'
                                        }
                                    }
                                }
                            }}
                            axisRight={null}
                            maxValue={maxMarker !== null ? maxMarker : "auto"}
                            axisBottom={axisBottom}
                            labelSkipWidth={12}
                            axisLeft={this.props.popupChart ? {
                                "tickSize": 5,
                                "tickPadding": 5,
                                "tickRotation": 0,
                                "legendOffset": -40,
                                "legendPosition": "middle"
                            } : null}
                            labelSkipHeight={12}
                            labelTextColor={"white"}
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                            //enableLabel={true}
                            //isInteractive={this.props.axises}
                            tooltip={({ id, value, color, indexValue }) => {
                                let tooltip = <strong>
                                    <span style={{ color: 'black' }}>
                                        {this.props.popupChart ? indexValue : HelperFunctions.getEnumLabel(+indexValue, Months, true)}:
                                    </span><span style={{ color }}> {value}</span>
                                </strong>

                                return tooltip;
                            }}
                        />
                    </div>
                    {this.props.paginator ?
                        <div style={{ textAlign: 'center' }}>
                            <Paginator numberOfPages={5} page={page} pageLabel={yearString} paginataorClick={this.paginataorClick} onlyArrows={true} />
                        </div>
                        : null}
                </div>
            </>
        )
    }
}

export default BarChart;